import { ContainerSaveAnimatedStyle, SaveAnimatedStyle } from './styles'
import { Loading } from '../Loading/Loading'
import { CheckedIcon } from '../../assets/icons/Checked'
import Fail from '../../assets/icons/fail'

type SaveAnimatedProps = {
  mensagem: String
}

/*
 * O GIF que ilustrava os estados de sucesso foi removido: e um arquivo com
 * FUNDO BRANCO SOLIDO (GIF nao carrega canal alfa), entao sobre o cartao
 * escuro aparecia como um retangulo branco no meio do modal. No lugar dele
 * entram elementos que ja vem do tema — o mesmo indicador de carregamento do
 * resto do app e o icone de confirmacao da marca —, que acompanham a paleta e
 * ainda economizam os 111 KB do GIF no bundle.
 */

const TEXTOS: Record<string, string> = {
  carregando: 'Carregando...',
  upload: 'Carregando...',
  convite: 'Convite enviado com sucesso.',
  semConvite: 'Nenhum convite enviado.',
  pronto: 'Pronto!',
  sucesso: 'Planilha importada com sucesso!',
}

export function SaveAnimated({ mensagem }: SaveAnimatedProps) {
  const chave = String(mensagem)
  const emAndamento = chave === 'carregando' || chave === 'upload'

  if (chave === 'failed') {
    return (
      <ContainerSaveAnimatedStyle>
        <SaveAnimatedStyle>
          <Fail />
          <h1>
            Algo de errado aconteceu, <br />
            confira sua planilha.
          </h1>
        </SaveAnimatedStyle>
      </ContainerSaveAnimatedStyle>
    )
  }

  return (
    <ContainerSaveAnimatedStyle>
      <SaveAnimatedStyle>
        {/* `semConvite` e um desfecho neutro, nao uma confirmacao: sai so com
            o texto, sem o icone de "deu certo". */}
        {emAndamento ? <Loading contrast={false} /> : null}
        {!emAndamento && chave !== 'semConvite' ? <CheckedIcon /> : null}
        <h1>{TEXTOS[chave] ?? ''}</h1>
      </SaveAnimatedStyle>
    </ContainerSaveAnimatedStyle>
  )
}
